export const useIsCypress = () => !!window.Cypress;
